module.exports = __webpack_public_path__ + "img/hontai_MidnightGray.9c4569ef.png";